<template>
  <v-form v-model="valid" :ref="$options.name">
    <h5>{{ $t('registration.subtitles.birthday') }}</h5>
    <v-layout wrap>
      <!--v-flex v-show="!isAdult" xs12>
        <span class="helper warning--text">{{ ageRestriction }}</span>
      </v-flex-->
      <v-flex xs6>
        <v-select
          :items="months"
          v-model="bmonth"
          menu-props="auto"
          :label="$t('registration.playerForm.month')"
          single-line
          @input="update"
          :rules="bmonthRules"
        />
      </v-flex>
      <v-flex xs3>
        <v-select
          :items="days"
          v-model="bdate"
          menu-props="auto"
          :label="$t('registration.playerForm.day')"
          single-line
          @input="update"
          :rules="bdateRules"
        />
      </v-flex>
      <v-flex xs3>
        <v-select
          :items="years"
          v-model="byear"
          menu-props="auto"
          :label="$t('registration.playerForm.year')"
          single-line
          @input="update"
          :rules="byearRules"
        />
      </v-flex>

    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: 'PlayerBirthday',
  props:{
    value: String
  },
  data() {
    return {
      valid: false,
      bmonth: '',
      bdate: '',
      byear: '',
      bmonthRules: [ (v) => !!v || this.$t('validation.birthdayRequired') ],
      bdateRules: [ (v) => !!v || this.$t('validation.birthdayRequired') ],
      byearRules: [ (v) => !!v || this.$t('validation.birthdayRequired') ]
    }
  },
  computed: {
    event() {
      return this.$store.state.events.find(e => e.id.toString() === this.$route.params.id)
    },
    months () {
      let d = new Date()
      d.setDate(1) // set to first to prevent short month spillover (i.e. 1.30 + 1 month = March 2)
      let m = []
      for (let i = 0;i < 12; i++) {
        d.setMonth(i)
        m.push({value: i+1, text: d.toLocaleString(this.$i18n.locale, {month: 'long'})})
      }
      return m
    },
    years () {
      if(!this.event) return []
      let y = []
      let maxYear = 1920
      let minYear = (new Date()).getFullYear() - 18
      for(let i = maxYear; i <= minYear; i++) {
        y.push(i)
      }
      return y
    },
    days () {
      let days = []
      let count = 31
      if (this.bmonth) {
        count = (new Date(Date.UTC(this.byear || 1999, this.bmonth, 0))).getDate()
      }
      for(let i = 0; i <= count; i++) {
        days.push(i+1)
      }
      return days
    },
    ageRestriction() {
      return this.$t('eventCard.bdateRestriction').replace('%1', this.bdateMin).replace('%2', this.bdateMax)
    },
    isAdult () {
      return this.$store.state.team.is_adult_registration === 1
    }
  },
  methods: {
    update () {
      this.$emit('input',
        // Build Date string -- YYYY-MM-DD
        this.byear.toString() + '-' +
        ((this.bmonth) < 10 ? '0' + (this.bmonth).toString() : (this.bmonth).toString()) + '-' +
        (this.bdate < 10 ? '0' + this.bdate.toString() : this.bdate.toString()))
    },
    validate () {
      return (this.$refs[this.$options.name].validate())
    }
  },
  watch: {
    'value'(val){
      if(!val) return
      const v = val.split('-')
      this.byear = parseInt(v[0])
      this.bmonth = parseInt(v[1])
      this.bdate = parseInt(v[2])
    }
  }
}
</script>

<style scoped>
.helper {
  text-align: center;
  display: block;
  margin-top: -1rem;
  margin-bottom: 1rem;
}
</style>